<div id="info-wrapper">
    <div class="content">
        <div class="content-header">
            <h1>403</h1>
        </div>
        <h2>Access denied!</h2>
        <p>You are not authorized to access this page.</p>
        <a href="/">Go Home</a>
    </div>
</div>